import { Tooltip } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import Icon from '@src/main/ui/components/common/Icon/Icon';
import { FC } from 'react';

interface EditButtonProps {
  onClickEdit: () => void;
  fontSize?: string;
}

const defaultProps = { fontSize: '25px' };

const EditButton: FC<EditButtonProps> = ({ onClickEdit, fontSize }) => (
  <Tooltip title="Edit dashboard">
    <IconButton size="small" onClick={onClickEdit} aria-label="Edit dashboard">
      <span style={{ fontSize }}>
        <Icon iconId="edit" />
      </span>
    </IconButton>
  </Tooltip>
);

EditButton.defaultProps = defaultProps;

export default EditButton;
